import React from "react";
import { Button } from "react-blueprint-library";
import { FORM_ID } from "../../../../constants/Forms";
import ReviewPersonalInfo from "./ReviewSignForm1/ReviewPersonalInfo";
import "../../../../assets/stylesheets/ReviewAndSign.scss";
import ReviewSignHeader from "./ReviewSignForm1/ReviewSignHeader";
import ReviewResAddress from "./ReviewSignForm1/ReviewResAddress";
import ReviewBusInfo from "./ReviewSignForm1/ReviewBusInfo";
import ReviewBrokerDealer from "./ReviewSignForm1/ReviewBrokerDealer";
import ReviewCCB from "./ReviewSignForm1/ReviewCCB";
import ReviewEOC from "./ReviewSignForm1/ReviewEOC";
import ReviewDirectDeposit from "./ReviewSignForm1/ReviewDirectDeposit";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../../constants/Contract.js";
import NavigationButtons from "../../../SharedComponents/NavigationButtons";
import { isCareerContract } from "../../../../common/Functions.js";
import { useDispatch } from "react-redux";
import { ccbActions } from "../../../../store/actions";
import ReviewAndSignFinOnly from "./ReviewAndSignFinOnly.js";
import { ReviewEditData } from "./ReviewSignForm1/ReviewEditItem/constants/index.js";
import ReviewEditItem from "./ReviewSignForm1/ReviewEditItem/index.js";

const ReviewSignForm1 = (props) => {
  const dispatch = useDispatch();

  const editToggle = (event) => {
    dispatch(ccbActions.setIsBack(false));
    switch (event.target.id) {
      case "pInfoEdit":
        props.toggleForm(FORM_ID.PERSONAL_INFO);
        break;
      case "resHistEdit":
        props.toggleForm(FORM_ID.RESIDENTIAL_HISTORY);
        break;
      case "bInfoEdit":
        props.toggleForm(FORM_ID.BUSINESS_INFO);
        break;
      case "eduEdit":
        props.toggleForm(FORM_ID.EDUCATION);
        break;
      case "empHistEdit":
        props.toggleForm(FORM_ID.EMPLOYMENT_HISTORY);
        break;
      case "psrEdit":
        props.toggleForm(FORM_ID.PERSONAL_SALES_RECORD);
        break;
      case "criminalEdit":
        props.toggleForm(FORM_ID.CCB_INTRO);
        break;
      case "regEdit":
        props.toggleForm(FORM_ID.REGULATORY_ACTION_DISCLOSURE);
        break;
      case "civEdit":
        props.toggleForm(FORM_ID.CIVIL_JUDICIAL_DISCLOSURE);
        break;
      case "customerEdit":
        props.toggleForm(FORM_ID.CUSTOMER_COMPLAINT_DISCLOSURE);
        break;
      case "termEdit":
        props.toggleForm(FORM_ID.TERMINATION_DISCLOSURE);
        break;
      case "financeEdit":
        props.toggleForm(FORM_ID.FINANCIAL_DISCLOSURE);
        break;
      case "ddEdit":
        props.toggleForm(FORM_ID.DIRECT_DEPOSIT);
        break;
      case "corpInfoEdit":
        props.toggleForm(FORM_ID.CORPORATE_INFO);
        break;
      case "memberCorpInfoEdit":
        props.toggleForm(FORM_ID.MEMBER_CORPORATE_INFO);
        break;
      case "corpCCBInfoEdit":
        props.toggleForm(FORM_ID.CORPORATE_CCB);
        break;
      case "CorpBInfoEdit":
        props.toggleForm(FORM_ID.CORPORATE_BUSINESS_ADDRESS);
        break;
      case "corpEOInfoEdit":
        props.toggleForm(FORM_ID.CORPORATE_ERRORS_OMISSIONS);
        break;
      case "corpDDEdit":
        props.toggleForm(FORM_ID.CORPORATE_DIRECT_DEPOSIT);
        break;
      case "resAddrEdit":
        props.toggleForm(FORM_ID.RESIDENTIAL_ADDRESS);
        break;
      case "brokeDealEdit":
        props.toggleForm(FORM_ID.BROKER_DEALER);
        break;
      case "ccbEdit":
        props.toggleForm(FORM_ID.CCB);
        break;
      case "eoEdit":
        props.toggleForm(FORM_ID.ERRORS_OMISSIONS);
        break;
      case "mmlisEdit":
        props.toggleForm(FORM_ID.MMLIS_INTRO);
        break;
      case "desgEdit":
        props.toggleForm(FORM_ID.PROFESSIONAL_DESIGNATION_CRIA);
      default:
        return;
    }
  };

  const handleShowBackModal = () => {
    if (
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP
    ) {
      props.toggleForm(FORM_ID.ERRORS_OMISSIONS);
    } else if (
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.MMLIS ||
      props.isMMLIS
    ) {
      props.toggleForm(FORM_ID.MMLIS_OBA_CRIA);
    } else if (
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY
    ) {
      dispatch(ccbActions.setIsBack(true));
      props.toggleForm(FORM_ID.FINANCIAL_DISCLOSURE);
    } else if (
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR
    ) {
      props.toggleForm(FORM_ID.PROFESSIONAL_DESIGNATION_CRIA);
    } else {
      props.toggleForm(FORM_ID.DIRECT_DEPOSIT);
    }
  };

  const handleNext = () => {
    dispatch(ccbActions.setIsBack(false));
    props.toggleForm(FORM_ID.REVIEW_SIGN_2);
  };

  const getReviewEditButtons = () => {
    const isCollegeInternContract =
      props?.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN;
    const isPreliminaryAppContract =
      props?.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY;
    const showPSRSection = props?.psrData?.length > 0;
    const isMMLIS =
      props?.isMMLIS ||
      props?.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.MMLIS;

    switch (props?.contracttypedesc) {
      case CONTRACT_TYPE_DESCRIPTIONS.CAREER_AGENT:
      case CONTRACT_TYPE_DESCRIPTIONS.CAREER_SAMPLING:
      case CONTRACT_TYPE_DESCRIPTIONS.ALTERNATE_AGENT:
      case CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN:
      case CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY:
      case CONTRACT_TYPE_DESCRIPTIONS.MMLIS:
        return ReviewEditData.CAREER_AGENT_SAMPLING.map(
          ({ btnId, labelId, labelText }, key, { length }) => {
            const showSubsectionHeader =
              labelId === "empHistReview" ||
              labelId === "criminalReview" ||
              labelId === "ddReview";
            const subSectionHeaderText =
              labelId === "empHistReview"
                ? "Employment History"
                : labelId === "criminalReview"
                  ? "Character, Credit, And Bonding"
                  : "";

            const isPSRSection = labelId === "psrReview";
            const psrLabelText =
              isPSRSection && props?.hasNYRegs
                ? labelText.replaceAll("Sales", "Production")
                : labelText;

            const skipReviewEditItem =
              (isPreliminaryAppContract && labelId === "ddReview") ||
              (isCollegeInternContract && labelId === "bInfoReview") ||
              (props?.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.MMLIS &&
                ((labelId === "eduReview" && !props.isCria) ||
                  labelId === "ddReview" ||
                  (labelId === "DesgReview" && !props.isCria))) ||
              (!isMMLIS && labelId === "mmlisReview") ||
              (labelId === "DesgReview" && !props.isCria && !props.isIA);

            return skipReviewEditItem ? (
              <React.Fragment key={key}></React.Fragment>
            ) : (
              <React.Fragment key={key}>
                {showSubsectionHeader && (
                  <div id="eyebrow-text">
                    <strong className="eyebrow">{subSectionHeaderText}</strong>
                  </div>
                )}
                {((isPSRSection && showPSRSection) || !isPSRSection) && (
                  <ReviewEditItem
                    navItemLabelId={labelId}
                    navItemLabelText={isPSRSection ? psrLabelText : labelText}
                    navItemBtnId={btnId}
                    editToggle={editToggle}
                  ></ReviewEditItem>
                )}
              </React.Fragment>
            );
          },
        );

      case CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS:
      case CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER:
        return ReviewEditData.RETIRED_BROKER_AGENT_EMERITUS.map(
          ({ labelId, labelText, btnId }, key) => {
            // Conditionally skip extra sections unless both addons are present
            const skipReviewEditItem =
              (labelId === "eduReview" && !props.isCria) ||
              (labelId === "DesgReview" && !props.isCria) ||
              (labelId === "mmlisReview" && !props.isMMLIS);
            return skipReviewEditItem ? (
              <React.Fragment key={key}></React.Fragment>
            ) : (
              <React.Fragment key={key}>
                <ReviewEditItem
                  navItemLabelId={labelId}
                  navItemLabelText={labelText}
                  navItemBtnId={btnId}
                  editToggle={editToggle}
                />
              </React.Fragment>
            );
          },
        );

      case CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP:
      case CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP:
        return ReviewEditData.BROKER_MEMBER_CORP.map(
          ({ labelId, labelText, btnId }, key) => {
            const showSubsectionHeader =
              (props?.contracttypedesc ===
                CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP &&
                (key === 0 || key === 5)) ||
              (props?.contracttypedesc ===
                CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP &&
                key === 0);
            const subSectionHeaderText =
              props?.contracttypedesc ===
                CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP && key === 0
                ? "CORPORATION"
                : "MEMBER OF CORPORATION";
            if (
              (props?.contracttypedesc ===
                CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP &&
                (key === 0 || key > 4)) ||
              props?.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP
            )
              return (
                <React.Fragment key={key}>
                  {showSubsectionHeader && (
                    <div id="eyebrow-text">
                      <strong className="eyebrow">
                        {subSectionHeaderText}
                      </strong>
                    </div>
                  )}
                  <ReviewEditItem
                    navItemLabelId={
                      props?.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP
                        ? "memberCorpInfoReview"
                        : labelId
                    }
                    navItemLabelText={labelText}
                    navItemBtnId={
                      props?.contracttypedesc ===
                        CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP && key === 0
                        ? "memberCorpInfoEdit"
                        : btnId
                    }
                    editToggle={editToggle}
                  ></ReviewEditItem>
                </React.Fragment>
              );
          },
        );
      case CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY:
      case CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR:
        return ReviewEditData.CRIA_ONLY.map(
          ({ labelId, labelText, btnId }, key) => (
            <React.Fragment key={key}>
              <ReviewEditItem
                navItemLabelId={labelId}
                navItemLabelText={labelText}
                navItemBtnId={btnId}
                editToggle={editToggle}
              ></ReviewEditItem>
            </React.Fragment>
          ),
        );
      default:
        return "";
    }
  };

  return (
    <div>
      {props.contracttypedesc ===
        CONTRACT_TYPE_DESCRIPTIONS.INDIVIDUAL_BROKER ||
      props.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY ? (
        <>
          <div id="reviewSignForm1">
            {props.contracttypedesc ===
            CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY ? (
              <ReviewAndSignFinOnly {...props} />
            ) : (
              <>
                <ReviewSignHeader step="1" title="Review Application" />

                <ReviewPersonalInfo
                  personalInformation={props.personalInformationData}
                  toggleForm={props.toggleForm}
                  candidatePresentationMode={props.candidatePresentationMode}
                />
                <hr />
                <ReviewResAddress
                  residentialAddress={props.resAddressData}
                  toggleForm={props.toggleForm}
                />
                <hr />
                <ReviewBusInfo
                  businessAddress={props.busInfoData}
                  toggleForm={props.toggleForm}
                />
                <hr />
                <ReviewBrokerDealer
                  brokerDealerInformation={props.brokerDealerData}
                  toggleForm={props.toggleForm}
                />
                <hr />
                <ReviewCCB
                  characterCreditBonding={props.ccbData}
                  toggleForm={props.toggleForm}
                />
                <hr />
                <ReviewEOC
                  errorsOmissionsCoverage={props.eocData}
                  toggleForm={props.toggleForm}
                />
                <hr />
                <ReviewDirectDeposit
                  directDepositInformation={props.ddInfoData}
                  toggleForm={props.toggleForm}
                />

                <NavigationButtons
                  onBack={() => {
                    props.toggleForm(FORM_ID.DIRECT_DEPOSIT);
                  }}
                  onNext={() => {
                    props.toggleForm(FORM_ID.REVIEW_SIGN_2);
                  }}
                  isLoading={false}
                  nxtbtnid={"reviewSign1NextBtn"}
                  bckbtnid={"reviewSign1BackBtn"}
                />
              </>
            )}
          </div>
        </>
      ) : (
        <>
          <ReviewSignHeader
            step="1"
            title="Review Application"
          ></ReviewSignHeader>
          <div id="reviewSignForm1">
            <div id="message-box" className="row">
              <div className="col-md-12" id="reviewCompletedText">
                <h1 id="headerText">
                  Here is your chance to review and edit your application before
                  submitting it.
                </h1>
                <div id="reviewCheckBox">
                  <span
                    id="reviewCheck"
                    className="icon-check-circle icon-lg"
                  ></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12" id="reviewCompletedText">
                <h3>You've completed all of the following sections.</h3>
              </div>
            </div>
            {getReviewEditButtons()}
            <NavigationButtons
              onBack={handleShowBackModal}
              onNext={handleNext}
              nxtbtnid={"reviewSign1NextBtn"}
              bckbtnid={"reviewSign1BackBtn"}
              isLoading={false}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ReviewSignForm1;
